import { cva } from "class-variance-authority";
export const labelClasses = cva([
    'font-medium',
    'text-base',
    'select-none'
], {
    variants: {
        disabled: {
            true: [
                'text-black/40'
            ],
            false: []
        },
        error: {
            true: [],
            false: []
        }
    },
    compoundVariants: [
        {
            disabled: false,
            error: false,
            className: [
                'text-gray-700'
            ]
        },
        {
            disabled: false,
            error: true,
            className: [
                'text-danger'
            ]
        }
    ]
});
export const clickableLabelClasses = cva([
    'select-none'
], {
    variants: {
        disabled: {
            true: [
                'text-black/40',
                'cursor-not-allowed'
            ],
            false: [
                'text-gray-700',
                'cursor-pointer'
            ]
        }
    }
});
export const requiredClasses = cva([
    'inline',
    'font-medium',
    'pl-1'
], {
    variants: {
        disabled: {
            true: [
                'text-black/40'
            ],
            false: [
                'text-danger'
            ]
        }
    }
});
export const helperClasses = cva([
    'text-sm',
    '!mt-0'
], {
    variants: {
        disabled: {
            true: [
                'text-black/40'
            ],
            false: [
                'text-gray-700'
            ]
        }
    }
});
export const errorClasses = cva([
    'text-sm',
    'text-danger'
]);
